import { useEffect, useState } from "react";
import OverView from "./abt_overview";
import ComHistory from "./abt_history";
import Vision from "./abt_vision";
import Location from "./abt_location";

import "../styles/common.css?ver=1";
import "../styles/is.css?ver=2";
import { useNavigate } from "react-router-dom";

interface AboutProps {
  tabIndex: number;
}

const About: React.FC<AboutProps> = ({ tabIndex }) => {
  const navigate = useNavigate();

  const [currentTab, setCurrentTab] = useState(tabIndex);

  const menuArr = [
    { name: "Overview", content: <OverView />, path: "abt_overview" },
    { name: "연혁", content: <ComHistory />, path: "abt_history" },
    { name: "비전", content: <Vision />, path: "abt_vision" },
    { name: "찾아오시는길", content: <Location />, path: "abt_location" },
  ];

  const selectMenuHandler = ({ index, path }: any) => {
    setCurrentTab(index);
    navigate(`/${path}`);
  };

  useEffect(() => {
    setCurrentTab(tabIndex);
    window.scrollTo(0, 0);
  }, [tabIndex]);

  return (
    <div>
      <div className="sub-visual subv-5">
        <h1>
          <span>About us</span>
          <p>최고의 경험, 신뢰할 수 있는 전문성으로 또 다른 세상을 열어갑니다.</p>
        </h1>
        <div className="sub-depth-1">
          <ul className="tab-list">
            {" "}
            {menuArr.map((tab, index) => (
              <li key={index} className={currentTab === index ? "active" : ""} onClick={() => selectMenuHandler({ index, path: tab.path })}>
                {tab.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>{menuArr[currentTab].content}</div>
    </div>
  );
};

export default About;
